import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Redirect, Route, useHistory } from 'react-router-dom';
import { useRhAuth } from '../../contexts/RhAuthContext';
import { LOGOUT_ACTION, LOGOUT_ACTION_SESSION_CODE_PARAM } from '../../model/store';
import { routes } from '../../route-list';
import { LoadingScreen } from './LoadingScreen';

const EmailVerificationGuard: React.FC<{ component: React.ComponentType<any>; [key: string]: any }> = ({
  component: Component,
  ...props
}) => {
  const { user, isLoading } = useRhAuth();
  const history = useHistory();
  const isVerificationPage = window.location.pathname === routes.AUTH_VERIFY_EMAIL;

  useEffect(() => {
    if (isVerificationPage || isLoading) return;
    if (user && user.email_verified === false) {
      history.replace(routes.AUTH_VERIFY_EMAIL, { email: user.email });
    }
  }, [user, history, isVerificationPage, isLoading]);

  if (isLoading) return <LoadingScreen />;
  if (!isVerificationPage && user && user.email_verified === false) return null;

  return <Component {...props} />;
};

export const PrivateRoute = ({ component, ...rest }: React.PropsWithChildren<any>) => {
  const { isAuthenticated, isLoading } = useRhAuth();
  const dispatch = useDispatch();

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (params.session === LOGOUT_ACTION_SESSION_CODE_PARAM) {
      dispatch({ type: LOGOUT_ACTION });
    }
  }, [dispatch]);

  if (isLoading) return <LoadingScreen />;

  if (!isAuthenticated) {
    return <Redirect to={routes.LOGIN} />;
  }

  return <Route render={props => <EmailVerificationGuard component={component} {...props} />} {...rest} />;
};
